'use client';

import { useState } from 'react';

import { twMerge } from 'tailwind-merge';

import { FishingWaterDetailMetadataFields } from '../../generated/graphql';
import { Pill, Variant } from '../Clickables/Pill/Pill';
import { Heading } from '../Heading/Heading';
import { Modal } from '../Modal/Modal';
import { ModalBody } from '../Modal/ModalBody';
import { Text } from '../Text/Text';

interface IProps {
  metadata: FishingWaterDetailMetadataFields[];
  outerClassName?: string;
}

interface ModalData {
  heading: string;
  description: string;
}

const getPillVariant = ({ variant }: { variant: string }): Variant => {
  switch (variant) {
    case 'danger':
      return 'pink';
    case 'warning':
      return 'pinkLight';
    default:
      return 'grey';
  }
};

export const FishingWaterMetadataPills = ({ metadata, outerClassName }: IProps) => {
  const [modalData, setModalData] = useState<ModalData | undefined>(undefined);

  return (
    <div
      className={twMerge('flex flex-wrap gap-3', outerClassName)}
      data-testid="MetadataPills section"
    >
      {metadata.length > 0 &&
        metadata.map(metadataObject => {
          const pillVariant = getPillVariant({ variant: metadataObject.variant });
          return (
            <Pill
              variant={pillVariant}
              size="sm"
              key={metadataObject.id}
              className="w-max font-semibold"
              dataTestId="metadata pill"
              onClick={() => {
                setModalData({
                  heading: metadataObject.name,
                  description: metadataObject.description,
                });
              }}
            >
              {metadataObject.name}
            </Pill>
          );
        })}
      {modalData && (
        <Modal
          isOpen={!!modalData}
          onClose={() => {
            setModalData(undefined);
          }}
        >
          <ModalBody>
            <Heading variant="sm" className="mt-5 mb-4">
              {modalData.heading}
            </Heading>
            <Text>{modalData.description}</Text>
          </ModalBody>
        </Modal>
      )}
    </div>
  );
};
